import { toast } from "@jsq/ds/core";
import type { ApolloError } from "@apollo/client";

const DEFAULT_MSG = "Something went wrong. Please try again.";

export function getApiErrorMessage(error: unknown, fallback = DEFAULT_MSG): string {
  const e = error as ApolloError | undefined;
  return (
    e?.graphQLErrors?.[0]?.message ||
    e?.networkError?.message ||
    (typeof e?.message === "string" && e.message) ||
    fallback
  );
}

export function showApiErrorToast(error: unknown, fallback?: string): void {
  toast.error(getApiErrorMessage(error, fallback));
}

/**
 * Apollo-compatible `onError` handler.
 * Passes the ApolloError to showApiErrorToast without the optional fallback
 * so the signature satisfies Apollo's MutationHookOptions.onError type.
 */
export const onApiError = (error: ApolloError): void => showApiErrorToast(error);
